"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["size", "id"];
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    icon: {
      height: 80,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(8),
      width: 80
    },
    iconSmall: {
      height: 40,
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(4),
      width: 40
    }
  };
});
function Loading(_ref) {
  var size = _ref.size,
    id = _ref.id,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Fade, {
    in: true,
    style: {
      transitionDelay: '100ms'
    },
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true,
    id: id,
    justifyContent: "center",
    spacing: 1,
    wrap: "wrap"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    zeroMinWidth: true
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.icon, {
      [classes.iconSmall]: size === 'small'
    }),
    color: "primary",
    disableShrink: true,
    size: size === 'small' ? 40 : 80
  }, props)))));
}